<div class="container-fluid home-component-container">
  <div class="fs-5 my-2">{{currentUser.firstName}}'s Wiki</div>
  <mat-tab-group class="tabs-group">
    <mat-tab label="Tasks">
      <app-task-home [isFolderNav]="false"></app-task-home>
    </mat-tab>
    <mat-tab label="Mails">
      <app-inbox-list-vertical></app-inbox-list-vertical>
    </mat-tab>
    <!-- <mat-tab label="Templates">
      <app-template-list></app-template-list>
    </mat-tab> -->
  </mat-tab-group>
</div>